import { render, staticRenderFns } from "./CategoryPanel.vue?vue&type=template&id=8613c6d6"
import script from "./CategoryPanel.vue?vue&type=script&lang=js"
export * from "./CategoryPanel.vue?vue&type=script&lang=js"
import style0 from "./CategoryPanel.vue?vue&type=style&index=0&id=8613c6d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports